import { Modal } from '@innovationdepartment/proxima-ui';
import RemoveTagFromBrandConfirmationView from './RemoveTagFromBrandConfirmation.View';

export type RemoveTagFromBrandConfirmationProps = {
  open: boolean;
  close: () => void;
  confirm: () => void;
  brandName: string;
  tagOriginalName: string;
  isLoading: boolean;
};

const RemoveTagFromBrandConfirmation = ({
  open,
  confirm,
  close,
  brandName,
  tagOriginalName,
  isLoading
}: RemoveTagFromBrandConfirmationProps) => (
  <Modal noPadding={false} open={open} title={`Remove Tag from ${brandName}?`}>
    <RemoveTagFromBrandConfirmationView
      confirm={confirm}
      close={close}
      brandName={brandName}
      tagOriginalName={tagOriginalName}
      isLoading={isLoading}
    />
  </Modal>
);

export default RemoveTagFromBrandConfirmation;
